import React from 'react';
import classes from './ThreeDotLoader.module.scss';
import classNames from 'classnames';

export type ThreeDotLoaderViewProps = {
  size: 'small' | 'medium';
};

export const ThreeDotLoaderView = ({ size }: ThreeDotLoaderViewProps): JSX.Element => {
  const loaderClasses = classNames(classes.ThreeDotLoader, {
    [classes.ThreeDotLoaderMedium]: size === 'medium',
    [classes.ThreeDotLoaderSmall]: size === 'small'
  });
  return (
    <div className={classes.LoaderContainer}>
      <div className={loaderClasses} />
    </div>
  );
};
